// Apolo IDE — fileMention (core PURO, sprint composer-anchor E9).
//
// Detecta o token `@file:`/`@folder:` que o usuário está digitando NO FIM da
// linha (end-anchored, igual ao detectSlashPrefix), pra abrir o autocomplete
// typeahead de arquivos. NÃO faz I/O — só parsing. A sintaxe `@file:<path>`
// resultante já é resolvida + injeta o conteúdo do arquivo no prompt pelo
// sistema de menções existente (lib/mentions.js). Reaproveita esse caminho —
// sem comando novo (a armadilha dos dois-sistemas-de-plugin do Pedro).

// `@file:` ou `@folder:` ancorado no fim, precedido por início/espaço.
const PREFIX_RE = /(^|\s)@(file|folder):([^\s@<>'"]*)$/i;

/**
 * @param {string} text
 * @returns {{ type: 'file'|'folder', partial: string, start: number, end: number } | null}
 *   start = índice do '@'; end = fim do texto. partial = path parcial após o ':'.
 */
export function detectFileMentionPrefix(text) {
  if (typeof text !== 'string' || text.length === 0) return null;
  const m = PREFIX_RE.exec(text);
  if (!m) return null;
  return {
    type: m[2].toLowerCase(),
    partial: m[3],
    start: m.index + m[1].length, // pula o (^|\s) → aponta pro '@'
    end: text.length,
  };
}

/**
 * Quebra o path parcial em diretório a listar + folha a filtrar.
 * "src/comp" → { dir: 'src', leaf: 'comp' } · "src/" → { dir: 'src', leaf: '' }
 * "comp" → { dir: '', leaf: 'comp' }
 * @param {string} partial
 * @returns {{ dir: string, leaf: string }}
 */
export function splitMentionPath(partial) {
  const p = typeof partial === 'string' ? partial : '';
  const i = p.lastIndexOf('/');
  if (i === -1) return { dir: '', leaf: p };
  return { dir: p.slice(0, i), leaf: p.slice(i + 1) };
}

/**
 * Substitui o token detectado pelo path escolhido. Diretório mantém a '/' final
 * e re-abre o menu (navegar fundo); arquivo fecha com espaço.
 * @param {string} text
 * @param {{ start: number, end: number, type: string }} detected
 * @param {{ path: string, isDirectory: boolean }} entry
 * @returns {string}
 */
export function applyFileMention(text, detected, entry) {
  const before = text.slice(0, detected.start);
  const after = text.slice(detected.end);
  const suffix = entry.isDirectory ? '/' : ' ';
  return `${before}@${detected.type}:${entry.path}${suffix}${after}`;
}
